import style from "./Notifications.module.css";
import Notification from "./Notification";
import { getType } from "./NotificationType";
import { Get, Put } from "../../../Services/Server";
import Url from "../../../Services/Url";
import { useState, useEffect } from "react";
import Pagination from "../../../Components/Pagination/Pagination";
import User from "../../../Services/User";
import { useNavigate } from "react-router-dom";

const Notifications = () => {
	const navigate = useNavigate();
	const [page, setPage] = useState(0);
	const [list, setList] = useState();
	const [view, setView] = useState("unread"); // "unread" or "all"
	const [unreadCount, setUnreadCount] = useState(0);
	const [allCount, setAllCount] = useState(0);

	const biodata = User.getBiodata();
	const userId = biodata.id;

	const formatTime = (dateString) => {
		const date = new Date(dateString);
		return date.toLocaleTimeString([], {
			hour: "numeric",
			minute: "2-digit",
			hour12: true,
		});
	};

	const groupNotifications = (notifications) => {
		const today = new Date();
		const yesterday = new Date(today);
		yesterday.setDate(today.getDate() - 1);
		const lastWeek = new Date(today);
		lastWeek.setDate(today.getDate() - 7);

		const isSameDay = (d1, d2) =>
			d1.getDate() === d2.getDate() &&
			d1.getMonth() === d2.getMonth() &&
			d1.getFullYear() === d2.getFullYear();

		const groups = {
			Today: [],
			Yesterday: [],
			"Last 7 Days": [],
			Older: [],
		};

		notifications.forEach((n) => {
			const createdAt = new Date(n.createdAt);
			if (isSameDay(createdAt, today)) {
				groups.Today.push(n);
			} else if (isSameDay(createdAt, yesterday)) {
				groups.Yesterday.push(n);
			} else if (createdAt >= lastWeek) {
				groups["Last 7 Days"].push(n);
			} else {
				groups.Older.push(n);
			}
		});
		return groups;
	};

	// Load counts
	useEffect(() => {
		Get(Url.countNotifications(userId, false)).then((cnt) => setUnreadCount(cnt));
		Get(Url.countNotifications(userId, null)).then((cnt) => setAllCount(cnt));
	}, [userId]);

	// Fetch notifications
	useEffect(() => {
		const fetchUrl =
			view === "unread"
				? Url.getNotifications(userId, false, page)
				: Url.getNotifications(userId, null, page);

		Get(fetchUrl).then((resp) => {
			setList(resp);
		});
	}, [page, view, userId]);

	const clicked = (newPage) => {
		setPage(newPage);
	};

	const handleClick = (e) => {
		navigate("" + e.id);
	};

	// Mark all as read
	const markAllAsRead = () => {
		Put(Url.markAllAsRead(userId))
			.then(() => {
				const fetchUrl =
					view === "unread"
						? Url.getNotifications(userId, false, page)
						: Url.getNotifications(userId, null, page);

				Get(fetchUrl).then((resp) => {
					setList(resp);
				});

				Get(Url.countNotifications(userId, false)).then((cnt) => setUnreadCount(cnt));
				Get(Url.countNotifications(userId, null)).then((cnt) => setAllCount(cnt));
			})
			.catch((err) => {
				console.error("Failed to mark all as read", err);
			});
	};

	return (
		<div className={style.Notifications}>
			<div className={style.Head}>
				<h2>Notifications</h2>
			</div>

			<div className={style.subHead}>
				<div className={style.btns}>
					<div
						onClick={() => {
							setView("all");
							setPage(0);
						}}
						className={view === "all" ? style.btn1 : style.btn2}
					>
						{allCount} All
					</div>
					<div
						onClick={() => {
							setView("unread");
							setPage(0);
						}}
						className={view === "unread" ? style.btn1 : style.btn2}
					>
						{unreadCount} Unread
					</div>
				</div>
				<button className={style.markAll} onClick={markAllAsRead}>
					Mark all as read
				</button>
			</div>

			<div className={style.Cont}>
				{list &&
					(() => {
						const grouped = groupNotifications(list.content);
						return Object.entries(grouped).map(([group, items]) =>
							items.length > 0 ? (
								<div key={group}>
									<h4 className={style.subheading}>{group}</h4>
									{items.map((n) => (
										<Notification
											key={n.id}
											onClick={handleClick}
											type={getType(
												n.noticeViews.find((nv) => nv.user.id === userId)?.viewed
													? 0
													: n.level
											)}
										>
											{n}
										</Notification>
									))}
								</div>
							) : null
						);
					})()}
			</div>

			{list && (
				<Pagination
					onClick={clicked}
					pageable={list.pageable}
					totalPages={list.totalPages}
				/>
			)}
		</div>
	);
};

export default Notifications;
